import {
  LOAD_SERVICES,
  LOAD_SERVICES_SUCCESS,
  UPDATE_SERVICE,
  UPDATE_SERVICE_SUCCESS,
  DELETE_SERVICE,
  DELETE_SERVICE_SUCCESS,
  CLEAR_SERVICES,
} from 'constants/ActionTypes';
import { getIntlMessage } from 'helpers/utilHelpers';
import { toggleServiceForm } from 'actions/ui/serviceTableActions';
import { getSearch } from 'selectors/settingsSelectors';

// Begin loading of the services
export const loadServices = () => {
  return {
    type: LOAD_SERVICES,
    payload: {
      resource: 'services',
      onSuccess: loadServicesSuccess,
      filters: {
        search: {
          selector: getSearch,
        },
      },
      onErrorMessage: getIntlMessage('service.load.error'),
    },
  };
};

// Update services if loading is succeed
export const loadServicesSuccess = (services) => {
  return {
    type: LOAD_SERVICES_SUCCESS,
    services,
  };
};

export const clearServices = () => {
  return {
    type: CLEAR_SERVICES,
  };
};

// Service update request
export const updateService = (values, resolve, reject, extraFields, onSuccess, onSuccessFunction) => {
  return {
    type: UPDATE_SERVICE,
    promise: { resolve, reject },
    payload: {
      resource: 'services',
      onSuccess: updateServiceSuccess,
      afterSuccess: toggleServiceForm,
      entityPrimaryKey: 'serviceId',
      onSuccessFunction,
    },
    values,
  };
};

// Service update success
export const updateServiceSuccess = (service) => {
  return {
    type: UPDATE_SERVICE_SUCCESS,
    service,
  };
};

// Sending a request to the server to delete service
export const deleteService = (serviceId) => {
  return {
    type: DELETE_SERVICE,
    payload: {
      resource: 'services',
      entityId: serviceId,
      onSuccess: deleteServiceSuccess,
      onErrorMessage: getIntlMessage('request.error'),
    },
  };
};

// Delete service if sending succeed
export const deleteServiceSuccess = (serviceId) => {
  return {
    type: DELETE_SERVICE_SUCCESS,
    serviceId,
  };
};
